import { quickFacts } from "@/mocks/sections";

export default function Facts() {
  return (
    <section id="facts" className="scroll-mt-16 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,5fr)_7fr] lg:gap-12">
          {/* 左侧说明 */}
          <div className="lg:sticky lg:top-24 lg:self-start">
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-[0.2em] text-accent-600">
              <i className="ri-lightbulb-line text-sm leading-none"></i>
              冷知识与典故 COLD FACTS
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              那些词背后的
              <br className="hidden lg:block" />
              冷知识与小典故
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              一个热词能流行起来，背后往往藏着语言演变、经典文学与社会心理的影子。我们把有趣的源头一一挖出来，讲给你听。
            </p>
            <div className="mt-6 flex items-center gap-3 rounded-lg bg-primary-100/60 p-4 ring-1 ring-primary-100">
              <i className="ri-double-quotes-l text-2xl leading-none text-primary-600"></i>
              <p className="text-sm leading-6 text-primary-900">
                「知识就像瓜，越挖越有味。」
                <span className="mt-1 block text-xs text-foreground-500">—— 吃瓜百科编辑部</span>
              </p>
            </div>
          </div>

          {/* 右侧卡片 */}
          <div className="grid gap-4 sm:grid-cols-2">
            {quickFacts.map((fact, i) => (
              <article
                key={fact.key}
                className="group flex flex-col rounded-lg bg-background-100 p-5 ring-1 ring-background-200 transition-colors hover:ring-primary-200"
              >
                <div className="flex items-center justify-between">
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
                    {fact.category}
                  </span>
                  <span className="font-heading text-3xl font-black text-background-300 transition-colors group-hover:text-accent-200">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                  {fact.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{fact.text}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}